// function for sticky navbar
const navbar = document.getElementById('articlesNavbar');

const onScroll = () => {
    const scroll = document.documentElement.scrollTop;

    if (scroll > 100) {
        navbar.classList.add('sticky');
    } else {
        navbar.classList.remove('sticky');
    }
};
window.addEventListener('scroll', onScroll);

// function for filtered estates
const clickEstate = function (e) {
    document.forms.formSubmit.submit();
};
const clickAll = function (e) {
    const url = window.location.href;
    if (url.includes('news')) {
        location.href = '/articles/news';
    } else if (url.includes('promos')) {
        location.href = '/articles/promos';
    } else if (url.includes('blogs')) {
        location.href = '/articles/blogs';
    } else {
        location.href = '/articles/news';
    }
};
const estates = document.getElementsByName('estate');
for (let i = 0; i < estates.length; i++) {
    if (i === 0) {
        estates[0].addEventListener('click', clickAll, false);
    } else {
        estates[i].addEventListener('click', clickEstate, false);
    }
}

// function for show and hide navbar
const navHeight = 70;
let lastScrollY = 0;
const delta = 10;
const isMobile = window.matchMedia(
    'only screen and (max-width: 991px)'
).matches;
let didScroll = false;

window.addEventListener('scroll', (e) => {
    if (isMobile) {
        showOrHideNav();
    }
});
window.addEventListener('resize', function () {
    const win = this;
    if (win.innerWidth < 991) {
        showOrHideNav();
    } else {
        return true;
    }
});

function showOrHideNav() {
    didScroll = true;
    setInterval(() => {
        if (didScroll) {
            scrolled();
            didScroll = false;
        }
    }, 250);
}

function scrolled() {
    const sy = window.scrollY;
    // only trigger if scrolled more than delta
    if (Math.abs(lastScrollY - sy) > delta) {
        // scroll down -> hide nav bar
        if (sy > lastScrollY && sy > navHeight) {
            navbar.classList.add('nav-up');
        }
        // scroll up -> show nav bar
        else if (sy < lastScrollY) {
            navbar.classList.remove('nav-up');
        }
        // update current scroll point
        lastScrollY = sy;
    }
}
